import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #TABLE-CELL
\*------------------------------------ */
:host {
  display: contents;
}

/**
 * Table cell
 * 1) The main table cell (td) within the table body and row
 */
.cat-c-table-cell {
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
  min-height: var(--cat-c-table-cell--min-height, calc(var(--size-base-unit) * 6));
  padding: var(--cat-c-table-cell-padding, var(--cat-space-3x-small) var(--cat-space-medium));
  border-block-end: 1px solid var(--cat-theme-color-border-subtle);
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  box-shadow: var(--cat-drag-cell-box-shadow, none);
}

/**
 * Table cell align center
 * 1) Aligns content to center of the cell
 */
.cat-c-table-cell--align-center {
  align-items: center;
  justify-content: center;
}

/**
 * Table cell align right
 * 1) Aligns content var(--rtlGradientToRight, 90deg) of the cell
 */
.cat-c-table-cell--align-right {
  align-items: end;
}

/**
 * Table cell justify conents space between
 * 1) Aligns content to left and right of the cell
 */
.cat-c-table-cell--space-between slot {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: var(--cat-space-2x-large);
}

/**
 * Table cell justify conents flex start
 * 1) Aligns content inline and to left of the cell
 */
.cat-c-table-cell--flex-start slot {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: var(--cat-space-2x-large);
}

/**
 * Table cell align top-left
 * 1) Aligns content to top-left of the cell
 */
.cat-c-table-cell--align-top-left {
  justify-content: flex-start;
  align-items: start;
}

/**
 * Table cell align top-right
 * 1) Aligns content to top-right of the cell
 */
.cat-c-table-cell--align-top-right {
  justify-content: flex-start;
  align-items: end;
}

/**
 * Table cell align bottom-left
 * 1) Aligns content to bottom-left of the cell
 */
.cat-c-table-cell--align-bottom-left {
  justify-content: flex-end;
  align-items: start;
}

/**
 * Table cell align bottom-right
 * 1) Aligns content to bottom-right of the cell
 */
.cat-c-table-cell--align-bottom-right {
  justify-content: flex-end;
  align-items: end;
}

/**
 * Table cell align top-center
 * 1) Aligns content to top-center of the cell
 */
.cat-c-table-cell--align-top-center {
  justify-content: flex-start;
  align-items: center;
}

/**
 * Table cell align bottom-center
 * 1) Aligns content to bottom-center of the cell
 */
.cat-c-table-cell--align-bottom-center {
  justify-content: flex-end;
  align-items: center;
}

/**
 * Table cell active shadow
 * 1) If isActiveShadow is set to true, then add a shadow to the right on scrollLeft
 */
.cat-is-active-shadow {
  position: relative;
}
.cat-is-active-shadow:after {
  content: "";
  display: block;
  position: absolute;
  background: linear-gradient(var(--rtlGradientToRight, to right), rgba(0, 0, 0, 0.19) 0%, rgba(0, 0, 0, 0) 100%);
  height: 100%;
  inset-block-start: 0;
  inset-inline-end: calc(calc(var(--size-base-unit) * 1.125) * -1);
  width: calc(var(--size-base-unit) * 1.125);
  z-index: -1;
}

/**
 * Shift over the shadow to not cover the right border
 */
.cat-is-active-shadow.cat-c-table-cell--border-right.cat-c-table-cell--frozen:after {
  inset-inline-end: calc(calc(var(--size-base-unit) * 1.125) * -1 - 1px);
}

/**
 * Table cell bulk action, expandable, draggable
 * 1) If isBulkAction or isExpandable or isDraggable is true, then align the content in a row.
 */
.cat-is-bulk-action:not(.cat-c-table-cell--loader),
.cat-is-expandable:not(.cat-c-table-cell--loader),
.cat-is-draggable:not(.cat-c-table-cell--loader) {
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

/**
 * Table cell mobile view
 * 1) If isMobileView is true, then align the content in a row with space between.
 */
.cat-is-mobile-view {
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

/**
 * Table cell title
 * 1) The container for the default slot content inside the table cell
 */
.cat-c-table-cell__title {
  display: contents;
  /**
   * Table cell tooltip
   * 1) Line clamp the content if it goes over two lines
   */
  /**
   * Table cell self foldable
   * 1) The cell that holds the table header cell & table cell content the overflow the screen
   */
}
.cat-c-table-cell--tooltip .cat-c-table-cell__title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cat-c-table-cell__self-foldable .cat-c-table-cell__title {
  padding-block: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(184px, min-content));
  grid-auto-flow: row;
  justify-content: flex-start;
  gap: 0 var(--cat-space-medium);
}

/**
 * Table cell checkox
 * 1) The inline checkbox that appears if bulk actions is true.
 */
.cat-c-table-cell__checkbox {
  margin-inline-end: var(--cat-space-medium);
  --cat-checkbox-field-margin-top: 0;
}

/**
 * Table cell border right
 * 1) Adds a border to the right of the cell
 */
.cat-c-table-cell--border-right {
  border-inline-end: 1px solid var(--cat-theme-color-border-subtle);
}

/**
 * Table cell expandable button
 * 1) If isExpandable is true, then display the expandable button
 */
.cat-c-table-cell__expandable-button {
  position: relative;
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
  transform: rotate(0);
  transform-origin: center center;
  margin-inline: calc(var(--cat-space-x-small) * -1) var(--cat-space-medium);
  /**
   * If isExpandableActive is true, then rotate the icon
   */
}
.cat-is-expandable-active .cat-c-table-cell__expandable-button {
  transform: rotate(180deg);
}

/**
 * Table cell draggable button
 * 1) If isDraggable is true, then display the button
 */
.cat-c-table-cell__draggable-button {
  position: relative;
  margin-inline: calc(var(--cat-space-x-small) * -1) var(--cat-space-medium);
}

.cat-drag-button-active .cat-c-table-cell__draggable-button {
  background-color: var(--cat-button--icon-only-ghost-active, var(--cat-theme-color-button-icon-default-background-active));
  border-color: transparent;
  color: var(--cat-theme-color-button-content-active);
}

/**
 * Table cell mobile view button
 * 1) If isMobileView is true, then display the button
 */
.cat-c-table-cell__mobile-view-button {
  position: relative;
  margin-inline: var(--cat-space-medium) calc(var(--cat-space-x-small) * -1);
}

/**
 * Table cell first
 * 1) Targets the first table cell in a row with the attr first
 */
.cat-is-first {
  padding-inline-start: var(--cat-space-6x-large);
}

/**
 * Table cell first nested child
 * 1) Targets the first table cell nested in a row with the attr first
 */
.cat-is-first.cat-is-expandable-nested-child {
  padding-inline-start: var(--cat-space-4x-large);
}

/**
 * Table cell selffoldable first nested child
 * 1) Targets the first table cell nested in a self foldable row with the attr first
 */
.cat-is-first.cat-is-expandable-nested-child.cat-c-table-cell__self-foldable {
  padding-inline-start: calc(var(--size-base-unit) * 12);
}

/**
 * Table cell self foldable item
 * 1) The table header cell & table cell content the overflow the screen
 */
::slotted(.cat-c-table-cell__self-foldable-item) {
  padding: var(--cat-space-3x-small) 0;
}

/**
 * Table cell frozen
 * 1) If frozen is true, then make the table cell sticky
 */
.cat-c-table-cell--frozen {
  position: sticky;
  inset-block-start: 0;
  border-top: 1px solid transparent;
  background-clip: padding-box;
  inset-inline-start: var(--cat-table-cell-left, 0);
  background-color: var(--cat-table-row-background);
  z-index: var(--cat-z-index-200);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}

/**
 * Table cell mobile view
 * 1) If isMobileView then set the border to transparent
 */
.cat-is-mobile-view {
  border-inline-end: 1px solid transparent;
}
`;
       